var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-overlay', {
    attrs: {
      "value": !_vm.online,
      "opacity": 0.85,
      "z-index": "500"
    }
  }, [_c('v-layout', {
    attrs: {
      "column": "",
      "align-center": ""
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "64",
      "width": "4",
      "color": "white"
    }
  }), _c('div', {
    staticClass: "mt-4 text-center connection-overlay__text"
  }, [_vm._v(" Потеряна связь с сервером."), _c('br'), _vm._v(" Переподключаюсь" + _vm._s(_vm.dots) + " ")])], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }